export default "__VITE_PUBLIC_ASSET__228ca669__"